/* unplugin-vue-components disabled */import { render } from "./headMenu.vue?vue&type=template&id=abacbee8"
import script from "./headMenu.vue?vue&type=script&lang=js"
export * from "./headMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__